module.exports = __webpack_public_path__ + "static/media/io.3ff21d10.png";